var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3346 15.667V16.3336C25.3346 16.7018 25.0362 17.0003 24.668 17.0003H17.0013V24.667C17.0013 25.0351 16.7028 25.3336 16.3346 25.3336H15.668C15.2998 25.3336 15.0013 25.0351 15.0013 24.667V17.0003H7.33464C6.96645 17.0003 6.66797 16.7018 6.66797 16.3336V15.667C6.66797 15.2988 6.96645 15.0003 7.33464 15.0003H15.0013V7.33365C15.0013 6.96546 15.2998 6.66699 15.668 6.66699H16.3346C16.7028 6.66699 17.0013 6.96546 17.0013 7.33365V15.0003H24.668C25.0362 15.0003 25.3346 15.2988 25.3346 15.667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.82624710de3ef8c5e06d1e1e6f5cc1ac.svg";
export { ForwardRef as ReactComponent };